let timer, map, BMap, markerObjs = [],
    baseIcon = 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png';
const createMap = () => {
    const dom = document.querySelector('#one_map');
    timer = setTimeout(() => {
        if (!Object.prototype.hasOwnProperty.call(window, 'AMap')) {
            clearTimeout(timer)
            createMap();
        } else {
            map = new window.AMap.Map(dom, {
                zoom: 10, //级别
                center: [116.397428, 39.90923], //中心点坐标
                viewMode: '3D' //使用3D视图
            });
        }
    }, 100);
}
const getMap = () => {
    if (map) {
        return map;
    }
    return null
}

const addMarker = (option) => {
    var marker = new window.AMap.Marker({
        icon: option.icon||baseIcon,
        position: [option.lng, option.lat]
    });
    map.add(marker);
    markerObjs.push(marker);
    map.setFitView();
}
const on = (type,fn)=>{
    map.on(type, (e)=>{
        fn(e.lnglat); 
    });
}

const removeOverlays = () => {
    markerObjs.forEach(overlay => {
        map.remove(overlay);
    });
}
export default {
    createMap,
    getMap,         
    BMap,
    addMarker,
    removeOverlays,
    on,
}


// WEBPACK FOOTER //
// ./src/package/one_map_amap.js